// JSON-LD schema builders for SEO.

const SITE_URL = "https://www.meguiarsizmit.com";

// Absolute-ize a possibly-relative image/URL for schema output.
const abs = (u) => (!u ? u : u.startsWith("http") ? u : `${SITE_URL}${u}`);

export function localBusiness(settings) {
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    name: settings?.brand_name || "Meguiar's İzmit",
    image: abs(settings?.logo) || `${SITE_URL}/logo.png`,
    "@id": SITE_URL,
    url: SITE_URL,
    telephone: settings?.phone_intl || "+905392317495",
    priceRange: "₺₺",
    address: {
      "@type": "PostalAddress",
      streetAddress: settings?.address || "İzmit, Kocaeli",
      addressLocality: "İzmit",
      addressRegion: "Kocaeli",
      addressCountry: "TR",
    },
    areaServed: ["İzmit", "Başiskele", "Kartepe", "Gölcük", "Derince", "Körfez", "Gebze", "Darıca", "Çayırova", "Dilovası", "Kocaeli"],
    openingHours: "Mo-Sa 09:00-19:00",
    sameAs: [settings?.instagram, settings?.facebook].filter(Boolean),
  };
}

export function serviceSchema({ name, description, url, image }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name,
    description,
    url: `${SITE_URL}${url}`,
    image: abs(image),
    provider: { "@type": "AutoRepair", name: "Meguiar's İzmit", areaServed: "Kocaeli" },
    areaServed: { "@type": "City", name: "Kocaeli" },
  };
}

export function faqSchema(faqs = []) {
  if (!faqs.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question || f.q,
      acceptedAnswer: { "@type": "Answer", text: f.answer || f.a },
    })),
  };
}

export function articleSchema({ title, description, image, url, datePublished }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    image: abs(image),
    url: `${SITE_URL}${url}`,
    author: { "@type": "Organization", name: "Meguiar's İzmit" },
    publisher: { "@type": "Organization", name: "Meguiar's İzmit" },
    datePublished: datePublished || undefined,
  };
}

export function breadcrumbSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: it.to ? `${SITE_URL}${it.to}` : undefined,
    })),
  };
}
